export var matchComponent = function (Component) { return function (c) {
    // React Component
    if (c.type === Component) {
        return true;
    }
    // Matching componentType
    if (c.props && c.props.componentType === Component) {
        return true;
    }
    return false;
}; };
export var chainCallbacks = function () {
    var callbacks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        callbacks[_i] = arguments[_i];
    }
    return callbacks
        .filter(function (callback) { return typeof callback === 'function'; })
        .reduce(function (accumulator, callback) {
        if (accumulator === null) {
            return callback;
        }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line
            accumulator.apply(null, args);
            // eslint-disable-next-line
            callback.apply(null, args);
        };
    }, null);
};
//# sourceMappingURL=utils.js.map